import { ReactNode } from 'react'

type Tone = 'default' | 'subtle' | 'muted' | 'brand' | 'inverse'

const tones: Record<Tone, string> = {
  default: 'bg-surface text-ink-primary',
  subtle: 'bg-surface-subtle text-ink-primary',
  muted: 'bg-surface-muted text-ink-primary',
  brand: 'bg-surface-brand-subtle text-ink-primary',
  inverse: 'bg-surface-inverse text-ink-inverse',
}

type Density = 'compact' | 'default' | 'spacious'

const densities: Record<Density, string> = {
  compact: 'py-14 lg:py-20',
  default: 'py-20 lg:py-28',
  spacious: 'py-28 lg:py-40',
}

interface SectionProps {
  children: ReactNode
  tone?: Tone
  density?: Density
  className?: string
  id?: string
}

export default function Section({
  children,
  tone = 'default',
  density = 'default',
  className = '',
  id,
}: SectionProps) {
  return (
    <section id={id} className={`${tones[tone]} ${densities[density]} ${className}`}>
      {children}
    </section>
  )
}
